export default "__VITE_ASSET__BWu42Iv5__"